import React from "react";
import { StyleSheet, Text } from "react-native";

import { type ValidationError } from "@/schemas/forms/error";

type ValidationMessageProps = {
  error: ValidationError;
};

function ValidationMessage({
  error,
}: ValidationMessageProps): React.JSX.Element {
  return (
    <Text style={[styles.validationText, styles.errorText]}>
      {error.message}
    </Text>
  );
}

const styles = StyleSheet.create({
  validationText: {
    fontSize: 12,
    marginBottom: 8,
    marginLeft: 4,
  },
  errorText: {
    color: "#F56565",
  },
});

export default ValidationMessage;
